<template>
    <div class="overflow-auto pb-1 mb-4 sm:mb-8 md:mb-14">
        <div class="tabs flex justify-between border-b border-white">
            <NuxtLink
                :to="localePath({ name: 'magazine' })"
                class="tab-link relative px-4 py-2 whitespace-nowrap"
                :class="{ 'tab-link--active': !$route.query.category }"
            >
                <T t="news.newest_category_label" />
            </NuxtLink>
            <NuxtLink
                v-for="category in $store.state.data.newsCategories"
                :key="category.slug"
                :to="localePath({ name: 'magazine', query: { category: category.slug } })"
                class="tab-link relative px-4 py-2 whitespace-nowrap"
                :class="{ 'tab-link--active': $route.query.category === category.slug }"
            >
                {{ category.name }}
            </NuxtLink>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsCategoryTabBar',
};
</script>

<style scoped>
.tab-link::after {
    content: '';
    @apply block absolute bottom-[-3px] left-0 w-full h-[5px] bg-blue-400 z-1 rounded-full opacity-0 transition-opacity;
}

.tab-link.tab-link--active {
    @apply font-bold;
}

.tab-link:hover::after,
.tab-link.tab-link--active::after {
    @apply opacity-100;
}
</style>
